import { CUSTOM_SENSOR_GET } from './constants';

const GetCustomSensorById = customSensorId => ({
  type: CUSTOM_SENSOR_GET,
  customSensorId
});

export { GetCustomSensorById };
